import React from 'react';
import './FloatingElements.css';

const FloatingElements = () => {
  const elements = [
    { id: 1, content: '🏆', style: { top: '30%', left: '10%', animationDelay: '0s', fontSize: '3rem' } },
    { id: 3, content: '👑', style: { top: '50%', left: '20%', animationDelay: '1s', fontSize: '3rem' } },
    { id: 5, content: <div className="wave"></div>, style: { top: '70%', left: '15%', animationDelay: '2s' } },
    { id: 6, content: <div className="circle"></div>, style: { top: '40%', right: '10%', animationDelay: '0.5s' } },
    { id: 7, content: '🏆', style: { top: '60%', right: '20%', animationDelay: '1.5s', fontSize: '3rem' } },
    { id: 9, content: '👑', style: { top: '80%', right: '15%', animationDelay: '2.5s', fontSize: '3rem' } },
  ];

  return (
    <div className="floating-elements">
      {elements.map(el => (
        <div key={el.id} className="floating-element" style={el.style}>
          {el.content}
        </div>
      ))}
    </div>
  );
};

export default FloatingElements;
